import angular from 'angular';
import { formatAwt } from '../utils';

const module = angular.module('whyline.filters.averageWaitTime', []);

const filter = () => averageWaitingTime => formatAwt(averageWaitingTime);

module.exports = module.filter('averageWaitTime', filter);
